import React, { useEffect, useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import MapPin from "../../../../icons/MapPin";
import Dot from "../../../../icons/Dot";
import EventContentData from "../auctionFloor/components/EventContentData";
import PropertyContentData from "../auctionFloor/components/PropertyContentData";
import BidHistorySection from "../auctionFloor/components/BidHistorySection";
import BidHistoryModel from "../auctionFloor/components/BidHistoryModel";
import {
  getAllBids,
  getAllWrongBids,
  getLatestBid,
  getLatestBidOfUser,
} from "services";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";

interface AuctionDetailsTabProps {
  eventData: any;
  setOpenDetailsTab: any;
  setDefaultActiveTabValue: any;
}

export default function AuctionDetailsTab({
  eventData,
  setOpenDetailsTab,
  setDefaultActiveTabValue,
}: AuctionDetailsTabProps) {
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });

  const [bidsEvent, setBidsEvent] = useState([]);
  const [wrongBidsEvent, setWrongBidsEvent] = useState([]);
  const [showBidHistoryModel, setShowBidHistoryModel] = useState(false);
  const [currentUserLatestBid, setCurrentUserLatestBid] = useState<any>(null);
  const [latestBid, setLatestBid] = useState<any>(null);
  const [amount, setAmount] = useState<any>(0);
  const isSwissAuction = eventData?.event_type === "Asset transfer";
  const filterSwissInitialBids = (bids: any[]) => {
    const initialBids = bids.filter((bid) => bid?.meta?.initial_bid === true);
    const nonInitialBids = bids.filter(
      (bid) => bid?.meta?.initial_bid !== true,
    );
    if (!initialBids.length) return bids;
    const lastInitialBid = initialBids[initialBids.length - 1];
    return [...nonInitialBids, lastInitialBid];
  };

  const init = async (uuid: any) => {
    if (uuid) {
      const allBid: any = await getAllBids(uuid);
      if (allBid) {
        const filteredBids = isSwissAuction
          ? filterSwissInitialBids(allBid)
          : allBid;
        setBidsEvent(filteredBids);
      }
      const lastBid: any = await getLatestBid(uuid);
      setLatestBid(lastBid);
      if (lastBid) {
        setAmount(lastBid.final_amount);
      } else {
        setAmount(parseInt(eventData.reserve_price));
      }
      const currentUserLastBid: any = await getLatestBidOfUser(uuid, user.uuid);
      setCurrentUserLatestBid(currentUserLastBid);
      const allWrongBids: any = await getAllWrongBids(
        eventData.uuid,
        user.uuid,
      );
      if (allWrongBids) {
        setWrongBidsEvent(allWrongBids);
      }
    }
  };

  useEffect(() => {
    init(eventData.uuid);
  }, []);

  const getAuctionTime = (dateTime: any) => {
    return `${DateTime.fromISO(dateTime)
      .setZone("Asia/Kolkata")
      .toFormat("dd MMMM yyyy")} ${DateTime.fromISO(dateTime)
      .setZone("Asia/Kolkata")
      .toFormat("hh:mm a")} (IST)`;
  };
  return (
    <div className="-mt-3 font-sans">
      <div
        className="flex items-center"
        onClick={() => {
          setDefaultActiveTabValue("past_events");
          setOpenDetailsTab(null);
        }}
      >
        <Button className=" bg-transparent pl-0 hover:bg-transparent">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M19.9998 13.5L7.74984 13.5L12.9998 18.75L12.3398 19.5L5.83984 13L12.3398 6.5L12.9998 7.25L7.74984 12.5L19.9998 12.5L19.9998 13.5Z"
              fill="#262626"
            />
          </svg>
        </Button>
        <h4 className="text-xl text-brand-textBlack">Auction Details</h4>
      </div>
      <div className="mt-2 flex flex-col lg:flex-row gap-2 lg:gap-5">
        <div className="w-full relative bg-white ">
          <div className="flex absolute top-0 left-0">
            <div className="uppercase bg-[#F1EAFF] pl-4 mid:pl-9 pr-8 mid:pr-14 py-1 clip-path-topRightFourSided text-xs font-sans font-semibold tracking-wider text-[#5D5FEF]">
              auction Ended
            </div>
          </div>
          <div className="m-2 mid:m-6">
            <div className="flex justify-end mt-8 mid:mt-0">
              <div className="bg-white py-1 px-3 lg:px-4 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
                <Dot />
                <span className="text-[12px] lg:text-xs font-sans pl-3 font-normal text-brand-textBlack tracking-widest">
                  ID {eventData?.listing_id}
                </span>
              </div>
            </div>
            <div className="mt-4 md:mt-0">
              <h3 className="text-brand-textBlack font-sans text-sm lg:text-base font-semibold capitalize">
                {`${eventData?.property_dump.asset?.name} - ${eventData?.property_dump?.sub_asset_type?.name} `}
              </h3>
              <div className="flex items-start mt-1">
                <MapPin className="mr-1 w-3 h-3" />
                <span className="text-[10px] lg:text-xs text-brand-textGrey capitalize">
                  {`${eventData?.property_dump?.city?.name}, ${eventData?.property_dump?.state?.name}`}
                </span>
              </div>
            </div>
            <div
              className={`border-l-[2px] py-3 mid:py-6 pl-2 mid:pl-6 flex flex-col sm:flex-row md:flex-col lg:flex-row  gap-2 mid:gap-11 bg-custom-card-grey border-brand-textBlack mt-6 mid:mt-7`}
            >
              <div className="min-w-[190px]">
                <div className="text-[10px] lg:text-xs">
                  Bidding Start Date and Time
                </div>
                <div className="text-xs mid:text-sm break-keep leading-8">
                  {getAuctionTime(eventData.start_date_time)}
                </div>
              </div>
              <div className="min-w-[190px]">
                <div className="text-[10px] lg:text-xs">
                  {" "}
                  Bidding End Date and Time
                </div>
                <div className="text-xs mid:text-sm break-keep leading-8">
                  {getAuctionTime(eventData.end_date_time)}
                </div>
              </div>
            </div>
            <div className="mt-6 mid:mt-10 pr-0 mid:pr-6">
              <BidHistorySection
                bidsEvent={bidsEvent}
                setShowBidHistoryModel={setShowBidHistoryModel}
                wrongBidsEvent={wrongBidsEvent}
                isSwissAuction={eventData?.event_type === "Asset transfer"}
              />
            </div>
          </div>
        </div>
        <div className="min-w-[280px] bg-brand-lightOrange ">
          <EventContentData
            data={eventData}
            latestBidAmount={amount}
            biddingType={eventData?.bidding_type}
            currentUserLatestBid={currentUserLatestBid}
            latestBid={latestBid}
            status="end"
            endTime={parseInt(eventData.final_end_date)}
          />
          <PropertyContentData
            bank={eventData?.property_dump?.bank?.name}
            state={eventData?.property_dump?.state?.name}
            city={eventData?.property_dump?.city?.name}
          />
        </div>
      </div>
      <BidHistoryModel
        open={showBidHistoryModel}
        setOpen={setShowBidHistoryModel}
        bidsEvent={bidsEvent}
        wrongBidsEvent={wrongBidsEvent}
        isSwissAuction={eventData?.event_type === "Asset transfer"}
      />
    </div>
  );
}
